import { getDownloadURL, UploadTask } from "firebase/storage";
import { useEffect, useState } from "react";

const useFirestorage = (uploadTask?: UploadTask) => {
    const [fileUrl, setDownloadUrl] = useState<string>();
    const [progress, setProgress] = useState<number>(0);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (!uploadTask) return

        setLoading(true);
        const unsubscribe = uploadTask.on(
            'state_changed',
            (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                setProgress(progress); ``
            },
            (error) => {
                setError(error?.message);
            },
            () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    setLoading(false);
                    setDownloadUrl(downloadURL);
                })
                    .catch((error) => setError(error))
                    .finally(() => setLoading(false));
            }
        );
        return () => {
            unsubscribe();
        };
    }, [JSON.stringify(uploadTask)]);


    return { loading, progress, fileUrl, error };
}
export default useFirestorage;